var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project)?_c('div',[_c('ArrowTimeline',{attrs:{"items":_vm.projectStates,"colors":_vm.colors}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }